import React from 'react';
import { useParams } from 'react-router-dom';
import ContractLineListing from './contract-line-listing';

const ContractLine = () => {
  const { contractHeaderId } = useParams();
  return <ContractLineListing key={contractHeaderId} />;
};

export default ContractLine;
